module.exports = __webpack_public_path__ + "img/tinder.1c8ac33.png";